import { CommonModule, NgFor, NgIf } from '@angular/common'
import { Component, inject } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { CapitalizePipe } from '../../../pipes/capitalize.pipe'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { select, Store } from '@ngrx/store'
import { SalaryComponent } from '../../../store/salary-components/salary-components.state'
import { Business } from '../../../store/business/business.state'
import { selectBusinesses } from '../../../store/business/business.reducer'
import { tap } from 'rxjs'
import { selectSalaryComponents } from '../../../store/salary-components/salary-components.selectors'
import {
  addSalaryComponent,
  deleteSalaryComponent,
  editSalaryComponent,
  loadSalaryComponents
} from '../../../store/salary-components/salary-components.actions'
import { REIMBURSEMENTS } from '../../../store/state.constants'
import { loadBusinesses } from '../../../store/business/business.actions'

@Component({
  selector: 'app-reimbursements',
  imports: [
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CapitalizePipe,
    HasPermissionDirective
  ],
  templateUrl: './reimbursements.component.html',
  styleUrl: './reimbursements.component.scss'
})
export class ReimbursementsComponent {
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  private store = inject(Store)
  //States
  form!: FormGroup
  customInput = ''
  showCustomInput = false
  currentStep = 1
  selectedBusiness = ''
  businesses!: (SalaryComponent & { businessName: string; originalIndex: number })[]
  businessesList: Business[] = []
  operation = 'Add'
  reimbursements: SalaryComponent[] = []
  itemId = ''

  //Add modal for the items
  //@ViewChild('addEarningModal', { static: true })
  //earningModalTemplate: TemplateRef<unknown>

  //@ViewChild('deleteModal', { static: true })
  //deleteModalTemplate: TemplateRef<unknown>

  businesses$ = this.store.pipe(
    select(selectBusinesses),
    tap(businesses => {
      this.businessesList = businesses
    })
  )
  reimbursements$ = this.store.pipe(
    select(selectSalaryComponents(REIMBURSEMENTS)),
    tap(reimbursements => {
      this.reimbursements = reimbursements
      this.filteredItems()
    })
  )

  constructor() {
    this.initializeForm()
    this.store.dispatch(loadBusinesses({ params: null, page: 1, limit: 10 }))
    this.store.dispatch(loadSalaryComponents({ componentType: REIMBURSEMENTS, belongsTo: null }))
    this.businesses$.subscribe()
  }

  initializeForm() {
    this.form = this.fb.group({
      belongsTo: ['', Validators.required],
      name: ['', Validators.required],
      description: [''],
      componentType: [REIMBURSEMENTS],
      info: this.fb.group({
        deductionPlan: ['other'],
        payType: ['fixedPay'],
        calculationType: ['flatAmount'],
        paymentFrequency: ['monthly'],
        taxDeductionPreference: ['subsequentPayrolls'],
        taxable: [true],
        isInCTC: [true],
        isInFBP: [true],
        proRataBasis: [true],
        EPFContribution: [true],
        ESIContribution: [true],
        optional: [true]
      })
    })
  }

  onOtherSelected() {
    this.showCustomInput = true
    this.customInput = '' // Clear custom input when switching to "other"
  }
  onSelectionChange() {
    this.showCustomInput = false // Hide the custom input
    this.customInput = '' // Clear custom input when switching away from "other"

    // Update form value to selected radio button value
    const selectedValue = this.form.get('info.paymentFrequency')?.value
    if (selectedValue !== 'other') {
      this.form.get('info.paymentFrequency')?.setValue(selectedValue)
    }
  }

  sendDataToParent() {
    if (this.showCustomInput) {
      this.form.get('info.paymentFrequency')?.setValue(this.customInput)
    }
    switch (this.operation) {
      case 'Add':
        this.store.dispatch(addSalaryComponent({ salaryComponent: this.form.value }))
        break
      case 'Edit':
        this.store.dispatch(
          editSalaryComponent({ id: this.itemId, salaryComponent: this.form.value })
        )
        break
      case 'Delete':
        this.store.dispatch(
          deleteSalaryComponent({ id: this.itemId, componentType: REIMBURSEMENTS })
        )
        break
      default:
        break
    }
    this.onClose()
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  openModel(modal: unknown) {
    this.operation = 'Add'
    this.itemId = ''
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }
  openEditModal(modal: unknown, itemData: SalaryComponent) {
    this.operation = 'Edit'
    this.itemId = itemData.id
    this.form.get('belongsTo')?.setValue(itemData.belongsTo)
    this.form.get('name')?.setValue(itemData.name)
    this.form.get('description')?.setValue(itemData.description)
    this.form.get('type')?.setValue(itemData.componentType)
    this.form.get('info')?.setValue(itemData.info)

    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }
  openDeleteModal(modal: unknown, itemData: SalaryComponent) {
    this.operation = 'Delete'
    this.itemId = itemData.id
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  // Filter the items based on the selected busisness
  filteredItems() {
    let item: SalaryComponent & { businessName: string; originalIndex: number }
    this.businesses = this.reimbursements.map((d, i) => {
      item = { ...d, businessName: '', originalIndex: i }
      this.businessesList.map(business => {
        if (d.belongsTo === business.id) {
          item.businessName = business.businessName //d
        }
      })
      item.originalIndex = i //d
      return item //d
    })
    //if (!this.selectedBusiness) {
    //  return this.businesses
    //}
    return this.businesses.filter(item => item.belongsTo === this.selectedBusiness)
    //return this.businesses
  }

  onBusinessSelect(event: Event) {
    const selectedId = (event.target as HTMLSelectElement).value
    if (selectedId) {
      this.store.dispatch(
        loadSalaryComponents({ componentType: REIMBURSEMENTS, belongsTo: selectedId })
      )
    }
  }

  //Function to check if the current step is valid
  isStepValid(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.form.get('name')?.valid
      case 2:
        return !!this.form.get('info')?.valid
      default:
        return false
    }
  }

  goToNextStep(): void {
    if (this.isStepValid()) {
      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  stepChange(newStep: number): void {
    if (this.isStepValid()) {
      this.currentStep = newStep
    }
  }

  onClose() {
    this.currentStep = 1
    this.modalService.dismissAll()
    this.form.reset()
    this.initializeForm()
  }
}
